import PredefinedIcon, {
    PredefinedIconType,
} from "../../icons/Icon/Predefined";
import SubNav from "../Desktop/LinkItems/SubNav";
import {
    LinkItemClickable,
    SubNavContainer,
} from "../Desktop/TopRow/TopLinkItems";
import React from "react";
import classNames from "classnames";
import useComponentVisible from "../../../../hooks/useComponentVisible";
import styled from "@emotion/styled";
import IconContainer from "../../icons/Icon/IconContainer";
import useNavigationStore from "../store";
import { css } from "@emotion/core";

export const StyledIconContainer = styled(IconContainer)`
    position: relative;
    display: flex;
    align-items: center;
    height: 21px !important;
    width: 21px !important;
    svg {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 21px !important;
        height: 21px !important;
    }
    ${({ theme }) => theme.breakpoints.from.medium.css`
        margin-right: 10px;
    `};
`;
interface iProps {
    active: boolean;
}
const StyledActiveSpan = styled.span<iProps>`
    ${({ active }) =>
        active &&
        css`
            text-decoration: underline;
            text-decoration-thickness: 2px;
        `};
`;

const Language = ({ section }: { section: any }) => {
    const { ref, isVisible, setIsVisible } = useComponentVisible(false);
    const [activeSection] = useNavigationStore((state) => [
        state.activeSection,
    ]);

    if (!section) return null;

    return (
        <SubNavContainer
            className={classNames({ active: isVisible })}
            ref={ref}
            onClick={() => setIsVisible(!isVisible)}
        >
            <LinkItemClickable className={classNames({ active: isVisible })}>
                <StyledIconContainer>
                    <PredefinedIcon type={PredefinedIconType.world} />
                </StyledIconContainer>
                <StyledActiveSpan active={activeSection === section.name}>
                    Deutsch
                </StyledActiveSpan>
            </LinkItemClickable>
            <SubNav subsections={section.subsections} isOpen={isVisible} />
        </SubNavContainer>
    );
};

export default Language;
